import { cartItemTokyoStyling } from "@made-people/blueprint-cart-item/blueprint";

cartItemTokyoStyling.override({
  slots: {
    base: "last:mb-4 grid grid-rows-[min-content_min-content_min-content_1fr] grid-cols-[100px_1fr_1fr] place-items-start w-full gap-x-4",
    name: "col-start-2 col-end-4 min-w-0 line-clamp-2 text-heading-xs row-start-1 row-end-2",
    customInfoComponentWrapper:
      "col-start-2 col-end-4 text-body-sm row-start-4 mt-1 [&>div]:px-1 [&>div]:py-0.5",

    // Meta data
    metaDataWrapper: "flex flex-row-reverse row-start-3",
    colorWrapper: "before:content-['|'] before:mr-2 ml-2",
    colorLabel: "hidden",
    colorValue: "text-body-sm",
    sizeWrapper: "",
    sizeLabel: "hidden",
    sizeValue: "text-body-sm",

    // Image
    image: "w-full object-cover h-full",
    imageWrapper:
      "col-start-1 col-end-2 row-start-1 row-end-5 flex relative aspect-portrait justify-center items-center w-full h-full",

    // Price
    priceWrapper:
      "col-start-3 row-start-4 self-end items-end flex flex-col flex-col-reverse w-full",
    price: "font-bold",
    oldPrice: "line-through text-sale-price text-body-sm",
    stockStatus: "",

    // Bundle
    triggerBundle: "col-start-2 col-end-3 row-start-5 row-end-6",
    bundleItemWrapper: "",
    bundleItemName: "",
    bundleItemImage: "",
    bundleItemImageWrapper: "",
    bundleItemSizeRow: "",
    bundleItemSizeLabel: "",
    bundleItemSizeValue: "",

    // Quantity picker
    quantityPickerWrapper:
      "row-start-4 row-end-5 col-start-2 col-end-3 flex gap-4 items-center text-label-sm self-end",
    quantityPickerAdd: "",
    quantityPickerRemove: "",
    quantityPickerValue:
      "text-body-md text-black [-webkit-text-fill-color:black] placeholder:text-center w-8 bg-transparent placeholder:text-black placeholder:opacity-100 [&::-moz-placeholder]:opacity-100 [&::-moz-placeholder]:text-black [&::-webkit-input-placeholder]:text-black [&::placeholder]:text-black [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [-moz-appearance:textfield] disabled:!text-black disabled:![-webkit-text-fill-color:black] disabled:!opacity-100",
    // Display quantity
    quantityValue: "hidden",

    // Remove button
    removeButton: "hidden",
  },
});
